<script setup>
import i18n from '@/i18n'
import { computed } from 'vue'

const props = defineProps({
  invitation: {
    type: Object,
    default: () => null,
  },
})

const state = computed(() => {
  if (!props.invitation) {
    return {
      text: i18n.t('Visitors.InvitationStatus.NoInvitation'),
      color: 'text-gray-400',
    }
  }
  if (props.invitation.checkout_time) {
    return {
      text: i18n.t('Visitors.InvitationStatus.CheckedOut', { time: new Date(props.invitation.checkout_time).toLocaleString() }),
      color: 'text-microsoft-blue-default',
    }
  }
  if (props.invitation.checkin_time) {
    return {
      text: i18n.t('Visitors.InvitationStatus.CheckedIn', { time: new Date(props.invitation.checkin_time).toLocaleString() }),
      color: 'text-green-700',
    }
  }
  return {
    text: i18n.t('Visitors.InvitationStatus.NotCheckedIn'),
    color: 'text-amber-600',
  }
})
</script>

<template>
  <span
    class="text-sm"
    :class="state.color"
  >
    {{ state.text }}
  </span>
</template>
